/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Length_FtInputs */

const en_field_length_ft = /** @type {(inputs: Field_Length_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Length (ft)`)
};

const es_field_length_ft = /** @type {(inputs: Field_Length_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longitud (pies)`)
};

const fr_field_length_ft = /** @type {(inputs: Field_Length_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longueur (ft)`)
};

const de_field_length_ft = /** @type {(inputs: Field_Length_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Länge (ft)`)
};

const ja_field_length_ft = /** @type {(inputs: Field_Length_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`長さ (フィート)`)
};

const zh_field_length_ft = /** @type {(inputs: Field_Length_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`长度 (英尺)`)
};

const ar_field_length_ft = /** @type {(inputs: Field_Length_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الطول (بالقدم)`)
};

const id_field_length_ft = /** @type {(inputs: Field_Length_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panjang (ft)`)
};

const it_field_length_ft = /** @type {(inputs: Field_Length_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunghezza (ft)`)
};

const ru_field_length_ft = /** @type {(inputs: Field_Length_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Длина (футы)`)
};

const pt_field_length_ft = /** @type {(inputs: Field_Length_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimento (pés)`)
};

const ko_field_length_ft = /** @type {(inputs: Field_Length_FtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`길이 (ft)`)
};

/**
* | output |
* | --- |
* | "Length (ft)" |
*
* @param {Field_Length_FtInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_length_ft = /** @type {((inputs?: Field_Length_FtInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Length_FtInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_length_ft(inputs)
	if (locale === "es") return es_field_length_ft(inputs)
	if (locale === "fr") return fr_field_length_ft(inputs)
	if (locale === "de") return de_field_length_ft(inputs)
	if (locale === "ja") return ja_field_length_ft(inputs)
	if (locale === "zh") return zh_field_length_ft(inputs)
	if (locale === "ar") return ar_field_length_ft(inputs)
	if (locale === "id") return id_field_length_ft(inputs)
	if (locale === "it") return it_field_length_ft(inputs)
	if (locale === "ru") return ru_field_length_ft(inputs)
	if (locale === "pt") return pt_field_length_ft(inputs)
	return ko_field_length_ft(inputs)
});